export default "__VITE_ASSET__CiIQYr1a__"